import { render, staticRenderFns } from "./set_mobile_page.vue?vue&type=template&id=32b1cf73&scoped=true&"
import script from "./set_mobile_page.vue?vue&type=script&lang=js&"
export * from "./set_mobile_page.vue?vue&type=script&lang=js&"
import style0 from "./set_mobile_page.vue?vue&type=style&index=0&id=32b1cf73&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1cf73",
  null
  
)

export default component.exports